import { services } from "../config/services";
import { customFetch } from "../customFetch";
import {
  CanaryFile,
  CoreSensitivity,
  EndpointLogLevel,
} from "../types/response/endpoints";
import {
  AutoUpdateVersionPolicy,
  InstallerBuildMode,
} from "../types/response/installers";
import { ConfigPlatform } from "@/utils/platforms";

export interface DefaultConfigRequest {
  id: string;
  platform: ConfigPlatform;
  groupConfigId: string | null | undefined;
  isAutoUpdateEnabled: boolean;
  autoUpdateBuildMode: InstallerBuildMode;
  isAutoUpdateProtectedBuildEnabled: boolean;
  autoUpdateVersionPolicy: AutoUpdateVersionPolicy;
  specificAutoUpdateVersion?: string;
  isQuarantineEnabled: boolean;
  isStartupGuardEnabled: boolean;
  isCoreEnabled: boolean;
  isCanaryEnabled: boolean;
  isBaselineEnabled: boolean;
  isMemoryDumpEnabled: boolean;
  isProcessProtectionEnabled: boolean;
  isRegistryProtectionEnabled: boolean;
  isFileSystemProtectionEnabled: boolean;
  isTamperEventReportingEnabled: boolean;
  isAppListCollectionEnabled: boolean;
  isLogCollectionEnabled: boolean;
  minLogLevel: EndpointLogLevel;
  hashPurgingTimeoutHours: number;
  heartbeatIntervalSeconds: number;
  allowedPaths: string[];
  tamperReportingExcludedPaths: string[];
  allowedRemoteIps: string[];
  protectedDirectories: string[];
  canaryFiles: CanaryFile[];
  coreSensitivity: CoreSensitivity;
  isSmbMonitoringEnabled: boolean;
  isSmbLockdownEnabled: boolean;
  firewallRuleTimeoutMinutes: number | null;
  isAggerServicesHidingEnabled: boolean;
  isEnhancedMemoryProtectionEnabled: boolean;
}

export interface CompanyConfigRequest {
  isAggerServiceEnabled: boolean;
  isConnectedToGlobalHashes: boolean;
  areEmailNotificationsEnabled: boolean;
  areInAppNotificationsEnabled: boolean;
  isAutoApproveEnabled: boolean;
  isAutoApprovePermanent?: boolean;
  defaultConfigs: DefaultConfigRequest[];
}

export const company = {
  getCompany: (companyId: string) =>
    customFetch(`${services.companies}/${companyId}`),
  getCompanyConfig: (companyId: string) =>
    customFetch(`${services.companies}/${companyId}/config`),
  getCompanies: (page: number, pageSize: number, hostName?: string) => {
    let url = `${services.companies}?PageNumber=${page}&PageSize=${pageSize}`;
    if (hostName) {
      url += `&Name=${hostName}`;
    }
    return customFetch(url);
  },
  updateCompanyConfig: (companyId: string, config: CompanyConfigRequest) =>
    customFetch(`${services.companies}/${companyId}/config`, {
      method: "PUT",
      body: JSON.stringify(config),
    }),
};
